(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_item-valor"] && !Shopify.designMode) return;
  try {
    if (!window.__verDentro) {
    window.__verDentro = true;

    // Una sola ventana para todos los videos de la página: se arma la primera
    // vez que alguien toca «Ver por dentro».
    let ventana = null;
    const armarVentana = () => {
      if (ventana) return ventana;
      ventana = document.createElement('dialog');
      ventana.className = 'ventana-video';
      ventana.setAttribute('aria-label', 'Video');
      ventana.innerHTML =
        '<div class="ventana-video__marco">' +
        '<button type="button" class="ventana-video__cerrar" aria-label="Cerrar">' +
        '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M1 1l12 12M13 1L1 13"/></svg>' +
        '</button><div data-lugar></div><p class="ventana-video__titulo"></p></div>';
      const cerrar = () => ventana.close();
      ventana.querySelector('.ventana-video__cerrar').addEventListener('click', cerrar);
      ventana.addEventListener('click', (e) => {
        if (e.target === ventana) cerrar();
      });
      ventana.addEventListener('close', () => {
        ventana.querySelector('[data-lugar]').replaceChildren();
      });
      document.body.appendChild(ventana);
      return ventana;
    };

    document.addEventListener('click', (e) => {
      const boton = e.target.closest('[data-ver-dentro]');
      if (!boton) return;
      const plantilla = boton.parentElement.querySelector('template[data-ver-dentro-video]');
      if (!plantilla) return;
      const v = armarVentana();
      const lugar = v.querySelector('[data-lugar]');
      lugar.replaceChildren(plantilla.content.cloneNode(true));
      v.querySelector('.ventana-video__titulo').textContent = boton.dataset.titulo || '';
      const video = lugar.querySelector('video');
      if (video) {
        video.muted = true;
        // Tocar el video lo pausa o lo sigue.
        video.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
        video.play?.()?.catch?.(() => {});
      }
      v.showModal();
      try {
        window.Shopify?.analytics?.publish?.('video_por_dentro', { pieza: boton.dataset.titulo || '' });
      } catch (err) {}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["compra-con-bump"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('compra-con-bump')) {
    const publicarVenta = (nombre, datos) => {
      try {
        if (/[?&]demo=1\b/.test(window.location.search)) return;
        window.Shopify?.analytics?.publish?.(nombre, datos || {});
        if (typeof window.clarity === 'function') window.clarity('event', nombre);
      } catch (e) {}
    };

    const resultadoDelQuiz = () => {
      let id = '';
      try {
        id = new URLSearchParams(window.location.search).get('resultado') || sessionStorage.getItem('quiz-resultado') || '';
      } catch (e) {}
      return id.toLowerCase();
    };

    // La animación de compra: se muestra y resuelve cuando termina, ya sin la capa.
    const animarCompra = (texto, imagen) => {
      const quieta = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const capa = document.createElement('div');
      capa.className = 'compra-animacion' + (quieta ? ' compra-animacion--quieta' : '');
      capa.setAttribute('role', 'status');
      capa.setAttribute('aria-live', 'polite');
      capa.innerHTML =
        '<div class="compra-animacion__caja"><div class="compra-animacion__escena" aria-hidden="true">' +
        '<span class="compra-animacion__halo"></span>' +
        '<span class="compra-animacion__chispa compra-animacion__chispa--1"></span>' +
        '<span class="compra-animacion__chispa compra-animacion__chispa--2"></span>' +
        '<span class="compra-animacion__chispa compra-animacion__chispa--3"></span></div>' +
        '<svg class="compra-animacion__renglones" viewBox="0 0 80 52" aria-hidden="true">' +
        '<path d="M14 13H50" pathLength="1"/><path d="M14 23H42" pathLength="1"/><path d="M14 33H30" pathLength="1"/>' +
        '<path class="compra-animacion__linea" d="M14 44H66" pathLength="1"/></svg>' +
        '<p class="compra-animacion__texto"></p></div>';
      const escena = capa.querySelector('.compra-animacion__escena');
      const tapa = document.createElement(imagen ? 'img' : 'span');
      if (imagen) {
        tapa.src = imagen;
        tapa.alt = '';
      } else {
        tapa.classList.add('compra-animacion__tapa--sin-imagen');
      }
      tapa.classList.add('compra-animacion__tapa');
      escena.insertBefore(tapa, escena.children[1]);
      capa.querySelector('.compra-animacion__texto').textContent = texto;
      document.body.appendChild(capa);
      return new Promise((listo) => {
        setTimeout(() => {
          capa.classList.add('compra-animacion--saliendo');
          setTimeout(() => {
            capa.remove();
            listo();
          }, quieta ? 0 : 180);
        }, quieta ? 380 : 950);
      });
    };

    // Una sola barra fija por página: la del primer botón que la tenga.
    const barraCompra = window.__barraCompra || (window.__barraCompra = { duena: null });

    class CompraConBump extends HTMLElement {
      connectedCallback() {
        this.dialogo = this.querySelector('dialog');
        this.barra = this.querySelector('[data-barra-fija]');
        this.capaPantalla = this.querySelector('[data-preparando-pantalla]');
        this.ocupado = false;

        this.querySelectorAll('[data-abrir]').forEach((boton) => {
          boton.addEventListener('click', () => this.alTocar(boton));
        });

        if (this.dialogo) {
          this.dialogo.querySelector('[data-si]')?.addEventListener('click', (e) => this.comprar(true, e.currentTarget));
          this.dialogo.querySelector('[data-no]')?.addEventListener('click', (e) => this.comprar(false, e.currentTarget));
          this.dialogo.querySelector('[data-cerrar]')?.addEventListener('click', () => this.cerrar());
          this.dialogo.addEventListener('click', (e) => {
            if (e.target === this.dialogo && !this.ocupado) this.cerrar();
          });
          this.dialogo.addEventListener('cancel', (e) => {
            if (this.ocupado) e.preventDefault();
          });
          this.dialogo.addEventListener('close', () => barraCompra.duena?.revisar?.());
        }

        // Al volver del pago con "atrás", la página puede quedar como estaba.
        this.alVolverAtras = (e) => {
          if (!e.persisted) return;
          this.ocupado = false;
          this.querySelectorAll('[aria-busy]').forEach((b) => b.removeAttribute('aria-busy'));
          this.prepararAviso(false);
          if (this.dialogo?.open) this.dialogo.close();
        };
        window.addEventListener('pageshow', this.alVolverAtras);

        this.aplicarTextoDelQuiz();

        if (this.barra) {
          if (barraCompra.duena && barraCompra.duena !== this && barraCompra.duena.isConnected) {
            this.barra.remove();
            this.barra = null;
          } else {
            barraCompra.duena = this;
            this.prepararBarra();
          }
        }
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.alVolverAtras);
        // La barra y el aviso viven en <body>: se van con el botón.
        if (this.capaPantalla && !this.contains(this.capaPantalla)) this.capaPantalla.remove();
        if (this.barra && !this.contains(this.barra)) this.barra.remove();
        if (barraCompra.duena === this) {
          barraCompra.duena = null;
          document.removeEventListener('scroll', this.alScrollear, true);
          window.removeEventListener('resize', this.alScrollear);
          document.body.classList.remove('con-barra-compra');
        }
      }

      aplicarTextoDelQuiz() {
        const id = resultadoDelQuiz();
        if (!id) return;
        const plantilla = this.querySelector('template[data-cta="' + CSS.escape(id) + '"]');
        if (!plantilla) return;
        const texto = plantilla.innerHTML.trim();
        this.querySelectorAll('[data-texto-boton], [data-texto-barra]').forEach((el) => (el.innerHTML = texto));
      }

      async alTocar(boton) {
        if (this.ocupado || this.animando) return;
        if (this.dataset.accion === 'ir') {
          const ancla = this.dataset.ancla && document.getElementById(this.dataset.ancla);
          if (ancla) {
            const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            ancla.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
          }
          return;
        }
        if (this.dataset.accion === 'enlace') {
          this.irAlEnlace();
          return;
        }
        if (this.dataset.animacion !== undefined) {
          this.animando = true;
          try {
            await animarCompra(this.dataset.animacion, this.dataset.animacionImagen);
          } finally {
            this.animando = false;
          }
        }
        if (this.dataset.bump && this.dialogo) {
          this.ocultarError();
          this.dialogo.showModal();
          publicarVenta('bump_ofrecido');
          return;
        }
        this.comprar(false, boton);
      }

      irAlEnlace() {
        const destino = this.dataset.enlace;
        if (!destino) return;
        try {
          // Conserva los parámetros del anuncio (utm, fbclid) y el resultado del quiz.
          const url = new URL(destino, window.location.origin);
          if (url.origin === window.location.origin) {
            new URLSearchParams(window.location.search).forEach((valor, clave) => {
              if (!url.searchParams.has(clave)) url.searchParams.set(clave, valor);
            });
          }
          publicarVenta('prelanding_clic', { destino: url.pathname });
          window.location.href = url.toString();
        } catch (e) {
          window.location.href = destino;
        }
      }

      cerrar() {
        if (this.dialogo?.open) this.dialogo.close();
      }

      prepararAviso(mostrar) {
        const enDialogo = this.dialogo?.open;
        // El aviso de pantalla completa va en <body>: dentro de la sección,
        // las secciones de más abajo le pasarían por encima.
        if (this.capaPantalla && this.capaPantalla.parentElement !== document.body) document.body.appendChild(this.capaPantalla);
        const capa = enDialogo ? this.dialogo.querySelector('[data-preparando]') : this.capaPantalla;
        this.dialogo?.querySelectorAll('[data-preparando]').forEach((c) => (c.hidden = true));
        if (this.capaPantalla) this.capaPantalla.hidden = true;
        if (mostrar && capa) capa.hidden = false;
      }

      async comprar(conBump, boton) {
        if (this.ocupado) return;
        this.ocupado = true;
        boton?.setAttribute('aria-busy', 'true');
        this.ocultarError();
        this.prepararAviso(true);
        if (this.dataset.bump) publicarVenta(conBump ? 'bump_aceptado' : 'bump_rechazado');
        publicarVenta('compra_iniciada', { con_bump: Boolean(conBump) });

        const items = [{ id: Number(this.dataset.variante), quantity: 1 }];
        if (conBump && this.dataset.bump) items.push({ id: Number(this.dataset.bump), quantity: 1 });

        const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          if (this.dataset.vaciar === 'true') {
            await fetch(raiz + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          }
          const respuesta = await fetch(raiz + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!respuesta.ok) throw new Error('cart/add ' + respuesta.status);
          window.location.href = raiz + 'checkout';
        } catch (error) {
          console.error(error);
          this.ocupado = false;
          boton?.removeAttribute('aria-busy');
          this.prepararAviso(false);
          this.mostrarError();
        }
      }

      mostrarError() {
        const error = this.dialogo?.open
          ? this.dialogo.querySelector('.compra-bump__error')
          : this.querySelector('.compra-bump__error--suelto');
        if (error) error.hidden = false;
      }

      ocultarError() {
        this.querySelectorAll('.compra-bump__error').forEach((el) => (el.hidden = true));
      }

      // El botón de compra que dispara la barra: el propio, o si este botón solo
      // baja a la oferta, el primero de la página que compra.
      compradorDeLaBarra() {
        if (this.dataset.accion !== 'ir') return this;
        return document.querySelector('compra-con-bump[data-accion="comprar"]') || this;
      }

      botonesDeCompra() {
        // Los botones que solo bajan a la oferta no cuentan: no abren el pago.
        return [...document.querySelectorAll('compra-con-bump:not([data-accion="ir"]) .compra-bump__boton:not(.compra-bump__boton--barra)')];
      }

      prepararBarra() {
        // La barra va en <body>: Horizon le pone z-index al contenido de cada
        // sección y, adentro, las secciones de más abajo le pasarían por encima.
        document.body.appendChild(this.barra);
        const boton = this.barra.querySelector('[data-barra-boton]');
        // «Baja a la oferta y después compra»: hasta que la persona llega a la
        // oferta, la barra la lleva ahí; desde la oferta para abajo, compra.
        const irPrimero = this.dataset.barraAccion === 'ir_y_comprar';
        const anclaOferta = () => document.getElementById(this.dataset.ancla || 'oferta');
        const llegoALaOferta = () => {
          const ancla = anclaOferta();
          return !ancla || ancla.getBoundingClientRect().top < window.innerHeight * 0.6;
        };
        const textoCompra = this.barra.querySelector('[data-texto-barra]');
        const textoIr = this.barra.querySelector('[data-texto-barra-ir]');
        const ponerTexto = () => {
          if (!irPrimero || !textoIr) return;
          const comprar = llegoALaOferta();
          textoCompra.hidden = !comprar;
          textoIr.hidden = comprar;
        };
        boton?.addEventListener('click', () => {
          if (irPrimero && !llegoALaOferta()) {
            const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            anclaOferta()?.scrollIntoView({ behavior: quieto ? 'auto' : 'smooth', block: 'start' });
            return;
          }
          const comprador = this.compradorDeLaBarra();
          comprador.alTocar(comprador.querySelector('.compra-bump__boton:not(.compra-bump__boton--barra)') || boton);
        });

        // Modos viejos: «al pasar» es el de ahora «sin otro botón», y «desde la
        // oferta» pasó a ser «desde un bloque» (la oferta, si no hay bloque).
        const viejos = { al_pasar: 'sin_otro_boton', desde_la_oferta: 'desde_bloque' };
        const modo = viejos[this.dataset.barra] || this.dataset.barra;
        const aLaVista = (b) => {
          const caja = b.getBoundingClientRect();
          return caja.height > 0 && caja.bottom > 0 && caja.top < window.innerHeight;
        };
        // Desde dónde aparece: el bloque «Inicio de la barra fija» o, si no hay,
        // el ancla del botón (la oferta). Una marca escondida (por ejemplo, en
        // un bloque que no se ve en el celular) no cuenta.
        const enPagina = (el) => el && el.getClientRects().length > 0;
        const inicioDeLaBarra = () =>
          [...document.querySelectorAll('[data-inicio-barra]')].find(enPagina) ||
          [document.getElementById(this.dataset.ancla || 'oferta')].find(enPagina) ||
          null;

        const mostrar = (visible) => {
          this.barra.dataset.visible = String(visible);
          this.barra.setAttribute('aria-hidden', String(!visible));
          boton?.setAttribute('tabindex', visible ? '0' : '-1');
        };

        let pedido = false;
        this.revisar = () => {
          pedido = false;
          ponerTexto();
          if (this.ocupado || document.querySelector('compra-con-bump dialog[open]')) return mostrar(false);
          if (modo === 'siempre') return mostrar(true);
          if (modo === 'desde_bloque') {
            // Sin marca en la página se porta como «siempre»: antes que dejar
            // el celular sin botón. Con marca, queda fija de ahí para abajo.
            const inicio = inicioDeLaBarra();
            return mostrar(!inicio || inicio.getBoundingClientRect().top < window.innerHeight);
          }
          mostrar(!this.botonesDeCompra().some(aLaVista));
        };
        this.alScrollear = () => {
          if (pedido) return;
          pedido = true;
          requestAnimationFrame(() => this.revisar());
        };
        document.addEventListener('scroll', this.alScrollear, { passive: true, capture: true });
        window.addEventListener('resize', this.alScrollear);

        // Deja lugar al final de la página para que la barra no tape el pie.
        const medir = () => {
          const alto = this.barra.offsetHeight;
          if (alto) document.body.style.setProperty('--alto-barra-compra', alto + 'px');
        };
        document.body.classList.add('con-barra-compra');
        medir();
        window.addEventListener('resize', medir);
        this.revisar();
      }
    }

    customElements.define('compra-con-bump', CompraConBump);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lista-con-iconos"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__listaIconosMovimiento) return;
    window.__listaIconosMovimiento = true;
    const iniciar = () => {
      if (!document.documentElement.classList.contains('venta-movimiento') || !('IntersectionObserver' in window)) return;
      const observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.dataset.mov = 'listo';
            observador.unobserve(e.target);
          });
        },
        { threshold: 0.2 }
      );
      document.querySelectorAll('.lista-iconos:not([data-mov])').forEach((lista) => {
        // Lo que ya se ve al cargar no se esconde.
        if (lista.getBoundingClientRect().top < window.innerHeight * 0.9) return;
        lista.querySelectorAll(':scope > .lista-iconos__item').forEach((item, i) => item.style.setProperty('--orden', String(i)));
        lista.dataset.mov = 'espera';
        observador.observe(lista);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pila-de-valor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pila-de-valor')) {
    class PilaDeValor extends HTMLElement {
      connectedCallback() {
        this.convertir();
        const items = [...this.querySelectorAll('.pila-valor__item')];
        items.forEach((item, i) => item.style.setProperty('--orden', String(i)));
        this.style.setProperty('--piezas', String(items.length));
        if (!('IntersectionObserver' in window)) {
          this.classList.add('pila-valor--visible');
          return;
        }
        this.observador = new IntersectionObserver(
          (entradas) => {
            if (entradas.some((e) => e.isIntersecting)) {
              this.classList.add('pila-valor--visible');
              this.observador.disconnect();
            }
          },
          { threshold: 0.25 }
        );
        this.observador.observe(this);
      }

      disconnectedCallback() {
        this.observador?.disconnect();
      }

      // Escribe un monto (en la moneda de quien mira) con el mismo formato que usa Shopify.
      formato(monto) {
        const muestra = this.dataset.muestra || '$1,000';
        const coincide = muestra.match(/1([.,'\s ]?)000/);
        const separador = coincide ? coincide[1] : ',';
        const entero = String(Math.round(monto)).replace(/\B(?=(\d{3})+(?!\d))/g, separador);
        let texto = coincide ? muestra.replace(coincide[0], entero) : entero;
        if (this.dataset.conCodigo === 'true' && this.dataset.moneda) texto += ' ' + this.dataset.moneda;
        return texto;
      }

      convertir() {
        const tasa = Number(window.Shopify?.currency?.rate || 1) || 1;
        let suma = 0;
        this.querySelectorAll('[data-monto]').forEach((el) => {
          const valor = Number(el.dataset.monto) * tasa;
          suma += valor;
          el.textContent = this.formato(valor);
        });
        const total = this.querySelector('[data-sumar]');
        if (total && suma > 0) {
          total.querySelector('[data-total]').textContent = this.formato(suma);
          total.hidden = false;
        }
      }
    }
    customElements.define('pila-de-valor', PilaDeValor);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["plato-animado"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('plato-animado')) {
    class PlatoAnimado extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        // En el editor se ve quieto y completo.
        if (window.Shopify?.designMode) return;
        this.dataset.mov = 'espera';
        this.observador = new IntersectionObserver(
          (entradas) => {
            if (!entradas.some((e) => e.isIntersecting)) return;
            this.dataset.mov = 'listo';
            this.observador.disconnect();
          },
          { threshold: 0.35 }
        );
        this.observador.observe(this);
      }

      disconnectedCallback() {
        this.observador?.disconnect();
      }
    }
    customElements.define('plato-animado', PlatoAnimado);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["texto-segun-quiz"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('texto-segun-quiz')) {
    class TextoSegunQuiz extends HTMLElement {
      connectedCallback() {
        const destino = this.querySelector('[data-texto-quiz]');
        let resultado = '';
        try {
          resultado = new URLSearchParams(window.location.search).get('resultado') || sessionStorage.getItem('quiz-resultado') || '';
        } catch (e) {}
        if (resultado && this.dataset.ocultarConResultado === 'true' && !(window.Shopify && window.Shopify.designMode)) {
          this.hidden = true;
          return;
        }
        if (resultado) {
          const plantilla = this.querySelector('template[data-resultado="' + CSS.escape(resultado.toLowerCase()) + '"]');
          if (plantilla && destino) destino.innerHTML = plantilla.innerHTML;
        }
        if (destino && destino.innerHTML.includes('{fecha}')) {
          const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
          const hoy = new Date();
          destino.innerHTML = destino.innerHTML.split('{fecha}').join(hoy.getDate() + ' de ' + meses[hoy.getMonth()] + ' de ' + hoy.getFullYear());
        }
      }
    }
    customElements.define('texto-segun-quiz', TextoSegunQuiz);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-pieza"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-pieza')) {
    const quieto = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cerca = null;
    let enJuego = null;
    if ('IntersectionObserver' in window) {
      // La imagen del video recién baja cuando el carrusel se acerca.
      cerca = new IntersectionObserver(
        (entradas) => {
          for (const e of entradas) {
            if (!e.isIntersecting) continue;
            const v = e.target;
            if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
            cerca.unobserve(v);
          }
        },
        { rootMargin: '400px' }
      );
      // Se reproduce mientras se ve casi entero.
      enJuego = new IntersectionObserver(
        (entradas) => {
          for (const e of entradas) {
            const v = e.target;
            if (e.isIntersecting) {
              if (!v.getAttribute('src') && v.dataset.src) v.setAttribute('src', v.dataset.src);
              v.play?.()?.catch?.(() => {});
            } else {
              v.pause?.();
            }
          }
        },
        { threshold: 0.6 }
      );
    }

    class VideoPieza extends HTMLElement {
      connectedCallback() {
        const v = this.querySelector('video');
        if (!v) return;
        if (!cerca) {
          if (v.dataset.poster) v.setAttribute('poster', v.dataset.poster);
          return;
        }
        cerca.observe(v);
        if (!quieto()) enJuego.observe(v);
      }

      disconnectedCallback() {
        const v = this.querySelector('video');
        if (v && cerca) {
          cerca.unobserve(v);
          enJuego.unobserve(v);
        }
      }
    }
    customElements.define('video-pieza', VideoPieza);
  }
  } catch(e) { console.error(e); }
})();

})();
